import { render, staticRenderFns } from "./OrderDetailFlashSale.vue?vue&type=template&id=c66b70a4&scoped=true&"
import script from "./OrderDetailFlashSale.vue?vue&type=script&lang=js&"
export * from "./OrderDetailFlashSale.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailFlashSale.vue?vue&type=style&index=0&id=c66b70a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66b70a4",
  null
  
)

export default component.exports